import { Component, OnInit } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-accepte-offre-condition',
  templateUrl: './accepte-offre-condition.component.html',
  styleUrls: ['./accepte-offre-condition.component.scss']
})
export class AccepteOffreConditionComponent implements OnInit {
  confirm = false;

  constructor(
    private dialogRef: DynamicDialogRef,
    private dialogConfig: DynamicDialogConfig
  ) {}

  ngOnInit(): void {
    console.log(this.confirm);
    console.log(this.dialogConfig.data);
    
  }

  accepted(): void {
    this.dialogRef.close({
      selection: this.dialogConfig.data.lancement,
      contrat: this.confirm
    });    
  }
}
